import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    pagination: {
      page: 1,
      size: 25
    },
    datas: [],
    totalCount: 0,
    detail: null,
    coinTypes: [],
    transferTypeData:[]
  },
  getters: {
    list: state => {
      return state.datas.map(item => ({
        ...item
      }));
    }
  },
  mutations: {
    setCoinTypes(state, payload) {
      state.coinTypes = payload;
    },
    setList(state, payload) {
      state.datas = payload.list.concat();
      state.totalCount = payload.totalCount;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setDetail(state, payload) {
      state.detail = payload;
    },
    setTransferType(state, payload) {
      state.transferTypeData = payload;
    }
  },
  actions: {
    getCoinTypes({ commit }) {
      api.getCoinTypes().then(({ data }) => {
        commit('setCoinTypes', data);
      });
    },
    reqList({ commit }, query) {
      api.reqList(query).then(({ data }) => {
        commit('setList', data);
        commit('setPagination', { size: query.size, page: query.page });
      });
    },
    create(context, data) {
      return api.create(data);
    },
    transfer(context, data) {
      return api.transfer(data).then(res=>{
        return res
      });
    },
    mockTransfer(context, data) {
      return api.mockTransfer(data).then(res=>{
        return res
      });
    },
    getTransferType({commit}){
      api.getTransferType().then(res=>{
        commit('setTransferType',res.data)
      })
    }
  }
};

appStore.registerModule('transferInnerMock', store);
